import * as React from 'react';
import * as PropTypes from 'prop-types';
import IconWrapper from './IconWrapper';

const IconWidgetCalendar = props =>
  React.createElement(
    IconWrapper,
    props,
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 40"
      className="block w-full h-full stroke-current fill-transparent"
    >
      <path
        d="M13.3333 11.6667V5M26.6667 11.6667V5M11.6667 18.3333H28.3333M8.33333 35H31.6667C33.5076 35 35 33.5076 35 31.6667V11.6667C35 9.82572 33.5076 8.33333 31.6667 8.33333H8.33333C6.49238 8.33333 5 9.82572 5 11.6667V31.6667C5 33.5076 6.49238 35 8.33333 35Z"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>,
  );

IconWidgetCalendar.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
};
export default IconWidgetCalendar;
